<template>
  <stripe-element
    ref="stripe-element"
    :stripe-elements="stripeElements"
    :label="$t('app.labels.credit_card.cvc')"
    :disabled="disabled"
    class="stripe-card-cvc"
    type="cardCvc"
    target="card-cvc"
  >
    <div id="card-cvc" />
  </stripe-element>
</template>

<script>
  import StripeElement from '@/components/Stripe/StripeElement/index.vue'

  /**
   * @module component - StripeCardCvc
   * @param {any} stripeElements
   */
  export default {
    name: 'StripeCardCvc',
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      stripeElements: {
        type: Object,
        default: null
      }
    },
    components: {
      StripeElement
    }
  }
</script>
